<template>
  <d-container :paddingless-mobile="true">
    <d-card>
      <d-card-row>
        <h2 class="title is-6">
          {{ $t('update_password') }}
        </h2>
      </d-card-row>
      <v-form
        :data="form"
        :url="$laravel.route('api.users.update.password', {user: user.id})"
        method="patch"
        @success="success()"
      >
        <d-card-row>
          <v-input
            v-model="form.old_password"
            name="old_password"
            type="password"
            :password-reveal="true"
          />
          <v-input
            v-model="form.new_password"
            name="new_password"
            type="password"
            :password-reveal="true"
          />
        </d-card-row>
        <d-card-row>
          <button
            class="button is-primary"
            type="submit"
          >
            {{ $t('save') }}
          </button>
        </d-card-row>
      </v-form>
    </d-card>
  </d-container>
</template>

<script>
export default {
  props: {
    user: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      form: {
        old_password: "",
        new_password: ""
      }
    };
  },
  methods: {
    success () {
      this.$set(this.form, "old_password", "");
      this.$set(this.form, "new_password", "");
    }
  }
};
</script>
